import { useTranslation } from 'react-i18next';
import { useSetPopup } from '../use-popup';
import { PopupOptionsSetter } from '../../../ts';

export const useShowMaintenancePopup = () => {
  const { t } = useTranslation();
  const { openPopup } = useSetPopup();

  const maintenanceOptions: PopupOptionsSetter = {
    title: "Mantenimiento Programado",
    children: "Estamos realizando actualizaciones técnicas para mejorar tu experiencia. Volveremos lo antes posible.",
    disableClickOutside: true,
    isOpenForced: true,
  };

  const showMaintenancePopup = () => {
    openPopup(maintenanceOptions);
  };

  return { showMaintenancePopup };
};